export const getApiResponseInJSON = async response => {
  const { ok } = response
  const json = await response.json()
  if (!ok) {
    const { message } = json
    throw new Error(message)
  }
  return json
}
